import apiClient from '../../lib/apiClient';
import logger from '../../lib/logger';

// Wrap an API call with structured logging through the universal logger
// (context: VENDOR_ANALYSIS). Use this as a queryFn / mutationFn. The label
// is the event prefix shown in logs (e.g. "SnapshotStrip:fetch").
export function loggedGet(label, path) {
  return async () => {
    const t0 = performance.now();
    logger.vendorAnalysis.info(`${label}:start`, { path });
    try {
      const result = await apiClient.get(path);
      logger.vendorAnalysis.info(`${label}:ok`, {
        path,
        duration_ms: Math.round(performance.now() - t0),
      });
      return result;
    } catch (err) {
      logger.vendorAnalysis.error(`${label}:failed`, {
        path,
        duration_ms: Math.round(performance.now() - t0),
        status: err?.status,
        code: err?.code,
      }, err);
      throw err;
    }
  };
}

export function loggedMutation(label, fn) {
  return async (input) => {
    const t0 = performance.now();
    logger.vendorAnalysis.info(`${label}:start`, { input_keys: input ? Object.keys(input) : [] });
    try {
      const result = await fn(input);
      logger.vendorAnalysis.info(`${label}:ok`, {
        duration_ms: Math.round(performance.now() - t0),
      });
      return result;
    } catch (err) {
      logger.vendorAnalysis.error(`${label}:failed`, {
        duration_ms: Math.round(performance.now() - t0),
        status: err?.status,
        code: err?.code,
      }, err);
      throw err;
    }
  };
}

export { apiClient };
